import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

// 引入通用样式
import './assets/css/global.css'
import vuetify from './plugins/vuetify'
import VueAnimateNumber from 'vue-animate-number'
import xss from 'xss'

Vue.use(VueAnimateNumber)
Vue.config.productionTip = false
Vue.prototype.xss = xss

// 配置根路径
axios.defaults.baseURL = 'http://erp.hbjxfm.com:8180/'

// 将axios挂载到vue原型
Vue.prototype.$axios = axios

// 设置全局变量
Vue.prototype.baseUrl = 'http://erp.hbjxfm.com:8180/'

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
